import { DOCUMENT } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvService } from '@core-mkt/services/env/env.service';
import { WistiaService } from '@core-mkt/services/wistia/wistia.service';
import { EnvironmentNoticeComponent } from '@core-mkt/shared/components/environment-notice/environment-notice.component';

@Component({
  selector: 'root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, EnvironmentNoticeComponent],
})
export class AppComponent implements OnInit {
  // Inject DOCUMENT token (not `document` directly) so Angular Universal's server-side DOM
  // implementation is used during SSR — this ensures the 'ace-mode' class is written into the
  // serialized HTML on the server, preventing a flash of incorrectly-styled content on first paint.
  private readonly document = inject(DOCUMENT);
  private readonly envService = inject(EnvService);
  // Resolves to the inert ServerWistiaService during SSR (see app.server.module.ts),
  // so the CTA click listener is only ever attached in the browser.
  private readonly wistia = inject(WistiaService);

  ngOnInit(): void {
    const { designMode } = this.envService.get.brandConfig;
    if (designMode === 'ace' || designMode === undefined) {
      this.document.body.classList.add('ace-mode');
    }

    // Wire the Vision CTA "Wistia Trigger" buttons (EPS-4629). Single app-wide,
    // idempotent init — the delegated listener covers every WYSIWYG template.
    this.wistia.initializeCtaTriggers();
  }
}
